import { render, staticRenderFns } from "./RecordingOptions.vue?vue&type=template&id=d953f724&scoped=true"
import script from "./RecordingOptions.vue?vue&type=script&lang=js"
export * from "./RecordingOptions.vue?vue&type=script&lang=js"
import style0 from "./RecordingOptions.vue?vue&type=style&index=0&id=d953f724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d953f724",
  null
  
)

export default component.exports